function isLocalHost(hostname = window.location.hostname) {
  return ["localhost", "127.0.0.1", "", "::1"].includes(hostname);
}

function createLinkConfig() {
  let linkConfig = {
    web: "/",
    h5: "/",
    online:
      "https://shunlong.s5.udesk.cn/im_client/?web_plugin_id=1538&group_id=1048",
    login: "https://fo.wsgoldfo002.com/Frontoffice/",
    disclaimer: "/disclaimer",
    risk: "/risk_disclosure",
    agreement: "/client_agreement",
    policy: "/privacy_policy",
    ios: "https://apps.apple.com/app/apple-store/id1630694317",
    android: [
      "https://downloads.huansscjyus.com/source/material/HSJY_tuijian.apk",
    ],
    android_backup:
      "https://mp-18b59665-8ace-4294-a961-e5d5164f6bef.cdn.bspapp.com/GW/2025_6/HSJY_GW_v320.apk",
  };

  /**
   * 本地开发或者UAT 设定:
   * isLocalHost() || window.location.hostname.includes("atbgovernor")
   *
   * 其余视为正式环境，动态域名
   */
  if (isLocalHost() || window.location.hostname.includes("atbgovernor")) {
    linkConfig.web = "https://huangsha.atbgovernor.com";
    linkConfig.h5 = "http://h5-hsha.atbgovernor.com/?utm_source=tuijian";
  } else {
    const baseDomain = window.location.hostname.replace(/^[^.]+\./, '');
    linkConfig.web = `${window.location.protocol}//www.${baseDomain}`;
    linkConfig.h5 = `${window.location.protocol}//h5.${baseDomain}/?utm_source=gw`;
  }

  linkConfig.disclaimer = linkConfig.web + linkConfig.disclaimer;
  linkConfig.risk = linkConfig.web + linkConfig.risk;
  linkConfig.agreement = linkConfig.web + linkConfig.agreement;
  linkConfig.policy = linkConfig.web + linkConfig.policy;

  return linkConfig;
}

const linkConfig = createLinkConfig();
const sourceUrl = "_s_u_l_";
const signature = "hsjy";
export { linkConfig, sourceUrl, signature };
